<div (click)="toggleState()" [class.disabled]="isDisabled" class="checkbox-container">
  <input
    type="checkbox"
    [checked]="state === true"
    [indeterminate]="state === null"
    [disabled]="isDisabled"
  />
</div>